import { gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid-premium';

export const getGroupedRowDataV2 = ({ api, id }) => {
  const rowIds = api?.getRowGroupChildren({ groupId: id });

  return rowIds?.length ? api.getRow(rowIds[0]) : null;
};

export const getGroupedRowData = (params) => {
  const rowIds = params?.api?.getRowGroupChildren({ groupId: params?.id });

  if (rowIds && rowIds.length > 0) {
    return params?.api?.getRow(rowIds[0]);
  }

  console.warn('No row data found!');
  return null;
};

export const getIsGroupingEnabled = (params) => {
  return params?.api?.state?.rowGrouping?.model?.length > 0;
};

// apiRef - this is MUI Data Grid api object
export const gridFilteredSortedRowIdsWithoutGroupsIdsCustomSelector = (apiRef) => {
  return gridFilteredSortedRowIdsSelector(apiRef).filter((rowId) => !rowId.includes('auto-generated-row'));
};

export const getCustomToolbarOptions = (apiRef) => {
  return {
    getRowsToExport: () => gridFilteredSortedRowIdsWithoutGroupsIdsCustomSelector(apiRef),
    fields: [...getGridActiveColumnsForExport(apiRef)],
  };
};

export const getGridActiveColumnsForExport = (apiRef) => {
  const { orderedFields, columnVisibilityModel } = apiRef.current.state.columns;

  return orderedFields.filter((field) => {
    if (field.startsWith('__')) return false;
    if (field in columnVisibilityModel && columnVisibilityModel[field] === false) return false;
    return true;
  });
};

export const handleExportAsCSV = ({ options = {}, apiRef, exportFileName }) => {
  const exportOptions = exportFileName
    ? {
        ...options,
        fileName: exportFileName,
      }
    : options;

  return apiRef.current.exportDataAsCsv(exportOptions);
};

export const booleanYesAndNoFilterOperators = [
  {
    label: 'Yes',
    value: 'is',
    getApplyFilterFn: () => (value) => value,
  },
  {
    label: 'No',
    value: 'isNot',
    getApplyFilterFn: () => (value) => !value,
  },
];
